import { useAppDispatch, useAppSelector } from '@/shared/hooks/useStore';
import { useAnnouncements } from '@/viewmodel/shared/versionCheck/hooks/useAnnouncements';
import { useNewVersionListener } from '@/viewmodel/shared/versionCheck/hooks/useNewVersionListener';
import { useSignedInUserId } from '@/viewmodel/shared/versionCheck/hooks/useSignedInUserId';
import { useVersionPolling } from '@/viewmodel/shared/versionCheck/hooks/useVersionPolling';
import {
  selectUpdateAvailable,
  updateDismissed,
} from '@/viewmodel/shared/versionCheck/state/versionCheckSlice';
import type { NewVersionViewState } from '@/viewmodel/shared/versionCheck/types';

export function useReleaseWatcherViewModel(): NewVersionViewState {
  const dispatch = useAppDispatch();
  useVersionPolling();
  useNewVersionListener();
  useAnnouncements(useSignedInUserId());
  const isOpen = useAppSelector(selectUpdateAvailable);

  return {
    isOpen,
    dismiss: () => dispatch(updateDismissed()),
    reload: () => globalThis.location.reload(),
  };
}
